export default {
  container: {
    height: '70px',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    alignItems: 'center',
    backgroundColor: '#fff',
    position: 'relative',
    zIndex: '20',
    padding: '20px',
    display: 'flex',
    justifyContent: 'space-between'
  }
}
